import cn from 'classnames'
import s from './Checkbox.module.scss'

interface Props {
  checked: boolean
  onChange: () => void
  className?: string
}

const defaultProps: Partial<Props> = {
  className: undefined,
}

const Checkbox = ({ checked, onChange, className }: Props): JSX.Element => (
  <label
    className={cn('checkbox', s.checkbox, className)}
    htmlFor="favori-checkbox"
  >
    <input type="checkbox" readOnly name="favori-checkbox" checked={checked} />
    <span
      className={s.checkmark}
      onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
        e.stopPropagation()
        onChange()
      }}
      onKeyPress={onChange}
      aria-label="toggleCheck"
      role="button"
      tabIndex={0}
    />
  </label>
)

Checkbox.defaultProps = defaultProps
export default Checkbox
